import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Menu} from '../../utils/menu/Menu';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import { deleteFaqCategoryAction, getFaqCategoriesAction } from '../../actions/faqAction';
import { FaqCategoryModal } from './utils/FaqCategoryModal';
import { Link } from 'react-router-dom';

const FaqCategories = (props) => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // get list
  const getList = useCallback(() => {
    dispatch(getFaqCategoriesAction()).then((data) => {
      setItems(data.items || []);
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  const handleDelete = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(deleteFaqCategoryAction(id)).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Запись удалена', {position: toast.POSITION.BOTTOM_RIGHT});
        getList();
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  // get list on change filter
  useEffect(() => {
    getList();
  }, [getList]);

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Категории базы знаний</h2>
      <FaqCategoryModal onSuccess={() => getList()} triggerWrap={true} trigger={<button type="button" className="heading__btn heading__btn--invite btn modal-btn">+ Добавить</button>} />
      <Link to={'/faq-settings'} className="heading__btn heading__btn--invite btn modal-btn" style={{"marginLeft": "10px"}}>Настройки</Link>
    </div>
    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Название" className="sort__item--name"/>
          <SortItem title="Изменена" className="sort__item--email"/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id + '_' + i.updated} className="users__item">
              <span className="users__name">{i.name}</span>
              <span className="users__email">{i.updated.split('.')[0].split('T').join(' ')}</span>
              <ButtonMore>
                <ul className="dropdown">
                  <li>
                    <Link to={'/faq/' + i.id} className="dropdown__item icon-mark">Вопросы</Link>
                  </li>
                  <li>
                    <FaqCategoryModal trigger={<div className="dropdown__item icon-edit">Редактировать</div>} triggerWrap={false} item={i} onSuccess={() => getList()}/>
                  </li>
                  <li>
                    <ConfirmModal trigger={<div className="dropdown__item icon-delete">Удалить</div>} triggerWrap={false} title={"Удалить категорию?"} handleOk={() => handleDelete(i.id)}/>
                  </li>
                </ul>
              </ButtonMore>
            </div>)
          }
        </div>
      </div>
    </div>
  </div>;
};


export default FaqCategories
